import {Box, Image, ImageProps, Show} from 'platform/foundation';
import styled from 'styled-components';

import {useState} from 'react';

import {omit} from 'ramda';

import {SkeletonLoadingBox} from '@dms/shared';

import {suffixTestId} from 'shared/web';

interface VehicleThumbnailProps extends ImageProps {
  hasUnifiedSurfaces: boolean;
}

export function VehicleThumbnail(props: VehicleThumbnailProps) {
  const [isLoading, setIsLoading] = useState(true);
  const imageProps = omit(['hasUnifiedSurfaces'], props);

  if (!props.hasUnifiedSurfaces) {
    return <Image {...imageProps} hasSpinner />;
  }

  return (
    <Box position="relative" height="100%">
      <Image
        {...imageProps}
        hasSpinner={false}
        onLoad={() => {
          setIsLoading(false);
          props.onLoad?.();
        }}
        onError={() => {
          setIsLoading(false);
          props.onError?.();
        }}
      />
      <Show when={isLoading}>
        <Box
          position="absolute"
          top={0}
          right={0}
          bottom={0}
          left={0}
          pointerEvents="none"
          borderRadius={props.borderRadius}
          overflow="hidden"
          data-testid={suffixTestId('loading', props)}
        >
          <SkeletonSurface>
            <SkeletonLoadingBox isLoading borderRadius={props.borderRadius} />
          </SkeletonSurface>
        </Box>
      </Show>
    </Box>
  );
}

const SkeletonSurface = styled.div`
  display: grid;
  height: 100%;
`;
